import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/testimonials.css';

export default class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      testimonials: [
        {
          id: 1,
          name: "Gorakshanath Kotkar",
          location: "Maharashtra",
          rating: 5,
          date: "March 2024",
          text: "For hassle-free hotel booking in Kerala, I recommended Kairaly Hotels & Holiday services. Their professionalism and attention to detail made our trip truly memorable. The hotels they booked were excellent and perfectly located.",
          image: "/assets/img/avatar.png"
        },
        {
          id: 2,
          name: "Mukund Sasturkar",
          location: "Pune, Maharashtra",
          rating: 5,
          date: "February 2024",
          text: "Wonderful experience of 10 days Kerala trip. They booked excellent properties covering from Trivandrum to Kochi. Driver was good and very helpful throughout our trip. Thanks to Mr Yadoo for it. Spacing of sightseeing arranged nicely so that we didn't have to rush anywhere & got free time also. I will definitely recommend Kairaly Holidays to those who want to visit & enjoy Kerala.",
          image: "/assets/img/avatar.png"
        },
        {
          id: 3,
          name: "Rajesh Sharma",
          location: "Mumbai",
          rating: 5,
          date: "January 2024",
          text: "Amazing experience with Kairaly Holidays! The houseboat stay in Alleppey was the highlight of our trip. The team was very professional and ensured all our needs were met. Will definitely book again!",
          image: "/assets/img/avatar.png"
        },
        {
          id: 4,
          name: "Priya Menon",
          location: "Bangalore",
          rating: 5,
          date: "December 2023",
          text: "Excellent service from start to finish. The team at Kairaly went above and beyond to make our family vacation perfect. The itinerary was well-planned, and all accommodations were top-notch. Highly recommended!",
          image: "/assets/img/avatar.png"
        },
        {
          id: 5,
          name: "Anand Kumar",
          location: "Chennai",
          rating: 4,
          date: "November 2023",
          text: "Great experience with Kairaly Holidays. The driver was very knowledgeable and friendly. The package was well-priced and covered all the major attractions. Will definitely use their services again.",
          image: "/assets/img/avatar.png"
        }
      ]
    };
  }

  nextSlide = () => {
    this.setState(prevState => ({
      currentIndex: (prevState.currentIndex + 1) % this.state.testimonials.length
    }));
  };

  prevSlide = () => {
    this.setState(prevState => ({
      currentIndex: (prevState.currentIndex - 1 + this.state.testimonials.length) % this.state.testimonials.length
    }));
  };

  goToSlide = (index) => {
    this.setState({ currentIndex: index });
  };

  render() {
    const { testimonials, currentIndex } = this.state;
    const currentTestimonial = testimonials[currentIndex];

    return (
      <div className="testimonials-section">
        <div className="testimonials-header">
          <h2 className="testimonials-title">Customer Testimonials</h2>
          <p className="testimonials-subtitle">
            What has sustained us for these ten years is our dedicated and enthusiastic staff. 
            Along with that, the travel agents who have been working with us since the beginning, 
            and the tourists who have seen Kerala through us - their kind words are our strength.
          </p>
          <div className="stats-badge">
            <span className="stat-item">1000+ Hotels</span>
            <span className="stat-item">5000+ Happy Travelers</span>
            <span className="stat-item">10+ Years Experience</span>
          </div>
        </div>

        <Grid>
          <Row>
            <Col xs={12}>
              <div className="testimonials-slider">
                {/* Main Testimonial Card */}
                <div className="testimonial-card">
                  <div className="testimonial-quote">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                      <path d="M10 11H6C6 8.79 7.79 7 10 7V11ZM10 17H6V13H10V17ZM18 11H14C14 8.79 15.79 7 18 7V11ZM18 17H14V13H18V17Z" fill="currentColor"/>
                    </svg>
                  </div>
                  
                  <div className="testimonial-content">
                    <p className="testimonial-text">"{currentTestimonial.text}"</p>
                    
                    <div className="testimonial-author">
                      <div className="author-avatar">
                        {currentTestimonial.image ? (
                          <img src={currentTestimonial.image} alt={currentTestimonial.name} />
                        ) : (
                          <div className="avatar-placeholder">
                            {currentTestimonial.name.charAt(0)}
                          </div>
                        )}
                      </div>
                      <div className="author-info">
                        <h4 className="author-name">{currentTestimonial.name}</h4>
                        <p className="author-location">{currentTestimonial.location}</p>
                        <div className="author-rating">
                          {[...Array(5)].map((_, i) => (
                            <svg 
                              key={i} 
                              width="16" 
                              height="16" 
                              viewBox="0 0 24 24" 
                              fill={i < currentTestimonial.rating ? "currentColor" : "none"}
                              stroke="currentColor"
                            >
                              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                            </svg>
                          ))}
                          <span className="rating-date">{currentTestimonial.date}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Navigation Buttons */}
                <button className="slider-nav prev" onClick={this.prevSlide}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>
                
                <button className="slider-nav next" onClick={this.nextSlide}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>

                {/* Dots Navigation */}
                <div className="slider-dots">
                  {testimonials.map((_, idx) => (
                    <button
                      key={idx}
                      className={`dot ${currentIndex === idx ? 'active' : ''}`}
                      onClick={() => this.goToSlide(idx)}
                    />
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Grid>

        {/* Trust Indicators */}
        <div className="trust-indicators">
          <div className="trust-item">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
            </svg>
            <div>
              <h4>4.9/5</h4>
              <p>Average Rating</p>
            </div>
          </div>
          <div className="trust-item">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="currentColor"/>
            </svg>
            <div>
              <h4>5000+</h4>
              <p>Happy Travelers</p>
            </div>
          </div>
          <div className="trust-item">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M12 8V12L15 15M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z" stroke="currentColor" strokeWidth="2"/>
            </svg>
            <div>
              <h4>10+ Years</h4>
              <p>Of Excellence</p>
            </div>
          </div>
          <div className="trust-item">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M3 9L12 3L21 9L12 15L3 9Z" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 15V21M9 18H15" stroke="currentColor" strokeWidth="2"/>
            </svg>
            <div>
              <h4>1000+</h4>
              <p>Hotel Partners</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}